import Box from "@mui/material/Box";

import { borderOverlaySx } from "~/features/andon/andon.styles";
import { AndonGridCell } from "~/features/andon/andon.types";
import { calculateAndonGridCellKey } from "~/features/andon/andon.utils";

type SelectionOverlayProps = {
  columns: number;
  rows: number;
  rowPitch: number;
  selectedCells: AndonGridCell[];
};

export default function SelectionOverlay({
  columns,
  rows,
  rowPitch,
  selectedCells
}: SelectionOverlayProps) {
  if (!selectedCells.length) return null;

  const selectedKeys = new Set(selectedCells.map(calculateAndonGridCellKey));
  const rowTemplate =
    rowPitch > 0 ? `repeat(${rows}, ${rowPitch}px)` : `repeat(${rows}, 1fr)`;

  return (
    <Box
      aria-hidden
      className="andon-selection-overlay"
      sx={borderOverlaySx(columns, rowTemplate)}
    >
      {Array.from({ length: rows }).flatMap((_, y) =>
        Array.from({ length: columns }).map((__, x) => {
          const cellKey = calculateAndonGridCellKey({ x, y });
          const selected = selectedKeys.has(cellKey);
          return (
            <div
              key={cellKey}
              className={
                selected ? "andon-selection-cell" : "andon-selection-cell-empty"
              }
              style={{
                boxSizing: "border-box",
                backgroundColor: selected
                  ? "rgba(25, 118, 210, 0.22)"
                  : undefined,
                outline: selected
                  ? "2px solid rgba(25, 118, 210, 0.7)"
                  : undefined,
                outlineOffset: "-2px"
              }}
            />
          );
        })
      )}
    </Box>
  );
}
